import { auth } from "../../../../helpers/firebaseConfig";

const BASE_URL = (process.env.REACT_APP_BUILDER_RESULTS_API_URL || "https://builder-results-api-554232563465.us-west1.run.app").replace(/\/$/, "");

function resultUrl(builderId, runId, suffix) {
  return `${BASE_URL}/model-builders/${encodeURIComponent(builderId)}/results/${encodeURIComponent(runId)}${suffix}`;
}

async function readJson(response) {
  if (!response.ok) throw new Error(`Builder Results API returned ${response.status}`);
  return response.json();
}

export async function fetchBuilderRunSummary(builderId, runId, signal) {
  const user = auth.currentUser;
  if (!user) throw new Error("Sign in is required to load the run summary.");
  const token = await user.getIdToken();
  const response = await fetch(resultUrl(builderId, runId, "/summary"), {
    headers: { Authorization: `Bearer ${token}` }, signal,
  });
  const data = await readJson(response);
  if (!Array.isArray(data.timeline) || !Array.isArray(data.exits)) throw new Error("Invalid run summary response.");
  return data;
}

export async function fetchSelectedLinksTimeline(builderId, runId, linkIds, signal) {
  const response = await fetch(resultUrl(builderId, runId, "/links/timeline"), {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ linkIds }),
    signal,
  });
  const data = await readJson(response);
  if (!Array.isArray(data.points)) throw new Error("Invalid selected-link timeline response.");
  return data;
}

export async function fetchSelectedLinksTravelTimeTimeline(builderId, runId, linkIds, maxTime, signal) {
  const numericIds = linkIds.map(Number);
  if (numericIds.some((id) => !Number.isSafeInteger(id))) throw new Error("Travel times require numeric link IDs.");
  const response = await fetch(resultUrl(builderId, runId, "/links/travel-time/timeline"), {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ linkIds: numericIds, maxTime }),
    signal,
  });
  const data = await readJson(response);
  if (!Array.isArray(data.points)) throw new Error("Invalid link travel-time response.");
  return data;
}

export function normalizeTimelinePoints(points) {
  return points.map((point) => ({
    time: Number(point.timeSeconds),
    arrived: point.totalArrived == null ? null : Number(point.totalArrived),
    queued: point.queued == null ? null : Number(point.queued),
    running: point.running == null ? null : Number(point.running),
  })).filter((point) => Number.isFinite(point.time))
    .sort((a, b) => a.time - b.time);
}

export function normalizeExitRows(exits) {
  if (!Array.isArray(exits)) return null;
  const rows = exits.map((exit) => ({
    exitId: String(exit.exitNodeId ?? exit.exitId ?? exit.nodeId ?? exit.exit_node_id ?? "").trim(),
    count: Number(exit.agentsArrived ?? exit.count ?? exit.agents_arrived),
    share: Number(exit.arrivalPercent ?? exit.percentage ?? exit.sharePercent ?? exit.share_percent),
  }));
  return rows.some((row) => !row.exitId || !Number.isFinite(row.count) || !Number.isFinite(row.share)) ? null : rows;
}
